import { $translate } from '@/utils/i18n';
export const tableConfig = {
    configuration: true,
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        selectBtn: true,
        clickState: true,
        leftOperation: true,
        height: 400,
        columns: [
            {
                label: $translate('lang.E3202102220012', { defaultText: '条码' }),
                align: 'center',
                prop: 'barcodeNo',
                filter: true,
                require: true,
                fixed: 'left',
                sort: true,
                width: 200
            },
            {
                label: $translate('lang.E3202102220011', { defaultText: '客户编码' }),
                align: 'center',
                prop: 'customerCode',
                filter: true,
                require: true,
                sort: true,
                width: 120
            },
            {
                label: $translate('lang.E3202102220030', { defaultText: '客户名称' }),
                align: 'center',
                prop: 'customerName',
                filter: true,
                require: true,
                sort: true,
                width: 120
            },
            {
                label: $translate('lang.E3202102220031', { defaultText: '仓库属性' }),
                align: 'center',
                prop: 'invType',
                filter: true,
                require: true,
                sort: true,
                width: 120
            },
            {
                label: $translate('lang.E3202102220022', { defaultText: '批次号' }),
                align: 'center',
                prop: 'batchId',
                filter: true,
                require: true,
                sort: true,
                width: 120
            },
            {
                label: $translate('lang.E3202102220013', { defaultText: '产品编码' }),
                align: 'center',
                prop: 'prodCode',
                filter: true,
                require: true,
                sort: true,
                width: 120
            },
            {
                label: $translate('lang.E3202102220014', { defaultText: '产品描述' }),
                align: 'center',
                prop: 'prodName',
                filter: true,
                require: true,
                sort: true,
                width: 120
            },
            {
                label: $translate('lang.E3202102220032', { defaultText: '校验时间' }),
                align: 'center',
                prop: 'runDate',
                filter: true,
                require: true,
                sort: true,
                width: 160
            },
            {
                label: $translate('lang.E3202102220033', { defaultText: '生产日期' }),
                align: 'center',
                prop: 'prodDate',
                filter: true,
                require: true,
                sort: true,
                width: 160
            },
            {
                label: $translate('lang.E3202102220034', { defaultText: '条码校验结果' }),
                align: 'center',
                prop: 'checkSatus',
                filter: true,
                require: true,
                sort: true,
                width: 120
            },
            {
                label: $translate('lang.E3202102220019', { defaultText: '是否重复上传' }),
                align: 'center',
                prop: 'reuploadFlag',
                filter: true,
                require: true,
                sort: true,
                width: 90
            },
            {
                label: $translate('lang.E3202207280010', { defaultText: '条码是否重复' }),
                align: 'center',
                prop: 'repeatBarcodeFlag',
                filter: true,
                require: true,
                sort: true,
                width: 90
            },
            {
                label: $translate('lang.E3202102220015', { defaultText: '上传人' }),
                align: 'center',
                prop: 'creationBy',
                filter: true,
                require: true,
                sort: true,
                width: 120
            },
            {
                label: $translate('lang.E3202102220016', { defaultText: '上传日期' }),
                align: 'center',
                prop: 'creationDate',
                filter: true,
                require: true,
                sort: true,
                width: 160
            },
            {
                label: $translate('lang.E3202102220020', { defaultText: '中心编码' }),
                align: 'center',
                prop: 'salescenterCode',
                filter: true,
                require: true,
                sort: true,
                width: 160
            },
            {
                label: $translate('lang.E32021022200211', { defaultText: '中心名称' }),
                align: 'center',
                prop: 'salescenterName',
                filter: true,
                require: true,
                sort: true,
                width: 160
            },
            {
                label: $translate('lang.E32021022200211', { defaultText: '中心名称导入' }),
                align: 'center',
                prop: 'salescenterNameUpload',
                filter: true,
                require: true,
                sort: true,
                width: 160
            }
        ],
        action: [
            {
                type: 'text',
                label: $translate('lang.E3202102230004', { defaultText: '删除' }),
                event: 'delete',
                size: 'small'
            }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
